<template>
  <section class="request-section">
    <div class="white-section container">
      <h1>REQUEST KITS</h1>
      <p>
        Ready to show that sun who's boss? Fill out your kit request below.<br/>
      </p>
      <p>
        Please note, kits are <strong>intended for external educational use only and are not to be used for in-office distribution.</strong>
      </p>
      <p>Please allow 4–6 weeks for your kits to arrive.</p>
      <p class="errorMsg-text" v-if="Object.keys(errors).length > 0">
        Please check the fields below to correct any errors and submit again. </p>
      <p class="errorMsg-text" v-if="submitError">{{ submitError }}</p>
      <p class="errorMsg-text" v-else-if="errors.form">
        {{ errors.form[0] }} </p>
      <div class="partial-submission" v-if="partialSubmission">
        <p><strong>Some items were submitted, but the complete request was not successful.</strong></p>
        <p>
          Submitted: {{ partialSubmission.submittedKitTypes.map(getKitTypeLabel).join(', ') }}.
        </p>
        <p>
          Not submitted: {{ getKitTypeLabel(partialSubmission.failedKitType) }}.
        </p>
        <p v-if="partialSubmission.requiresAdministratorReview">
          Please do not retry the full request. Contact an administrator for assistance.
        </p>
      </div>
      <form id="requestKitForm" @submit.prevent="sendFormData()">
        <div class="form-container" v-if="showEducatorKit">
          <div class="he">
            <h2>Educator kit request</h2>
            <p class="mb-1rem">
              Each verified NPI healthcare provider may receive one educator kit as a one-time request.
            </p>
          </div>
          <div class="im">
            <img src="@/assets/images/global/Sun-Heroes-EDUCATOR-Swag-Graphic.jpg" class="responsive"/>
          </div>
          <div class="ff">
            <div class="double-col">
              <p>
                <strong>Where should we ship your educator kit?</strong>
              </p>
            </div>
            <div class="form-field">
              <label><span>*</span>First name</label> <input type="text" v-model="educatorFirstName"
                                                             :class="{ invalid: errors.educatorFirstName }"
                                                             @input="clear_error('educatorFirstName')"/>
              <p class="errorMsg-text" v-if="errors.educatorFirstName">
                First name is required </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Last name</label> <input type="text" v-model="educatorLastName"
                                                            :class="{ invalid: errors.educatorLastName }"
                                                            @input="clear_error('educatorLastName')"/>
              <p class="errorMsg-text" v-if="errors.educatorLastName">
                Last name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="educatorAddressFirst"
                                                                   :class="{ invalid: errors.educatorAddressFirst }"
                                                                   @input="clear_error('educatorAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.educatorAddressFirst">
                The street address is required. </p>
            </div>
            <div class="form-field">
              <label>Street address 2</label> <input type="text" v-model="educatorAddressSecond"/>
            </div>
            <div class="form-field">
              <label><span>*</span>City</label> <input type="text" v-model="educatorCity"
                                                       :class="{ invalid: errors.educatorCity }"
                                                       @input="clear_error('educatorCity')"/>
              <p class="errorMsg-text" v-if="errors.educatorCity">
                City is required. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="educatorState" :class="{ invalid: errors.educatorState }"
                        @input="clear_error('educatorState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.educatorState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>Zip code</label> <input type="text" v-model="educatorZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.educatorZip }"
                                                           @input="clear_error('educatorZip')"/>
              <p class="errorMsg-text" v-if="errors.educatorZip">
                Zip code is required. </p>
            </div>
            <div class="superhero-cta" v-if="!showStudentKit">
              <div class="loader-container" :class="{ 'has-error': submitError && !showLoader }" aria-live="polite">
                <img v-if="showLoader" src="@/assets/images/global/loader.gif" alt="Submitting request"/>
                <p v-else-if="submitError" class="errorMsg-text">{{ submitError }}</p>
              </div>
             <button :disabled="disableSubmit || !!partialSubmission">Request <i class="fas fa-caret-right"></i></button>
             <div class="superhero-gif">
               <img src="@/assets/images/global/super-hero-4.gif" alt=""/>
             </div>
           </div>
          </div>
        </div>

        <div v-if="showEducatorPlaceholder" class="mb-3">
          <h2>Educator kit request</h2>
          <div>
            <p><strong>Looks like our educator kits are catching more rays than expected!</strong></p>
            <p>We’re temporarily out of stock, but more are on the way. Please check back soon to place your request.</p>
          </div>
        </div>

        <hr/>

        <div class="form-container" v-if="showStudentKit">
          <div class="he header-mobile">
            <h2>
              Student kit request & presentation information
            </h2>
            <p class="sh sub-header-mobile">
              These student kits are designed for educational use in schools, camps, and similar programs. To ensure fair distribution, <strong style="text-decoration: underline">each verified NPI healthcare provider may request up to 150 student kits per quarter while supplies last.</strong>
            </p>
            <p class="sh sub-header-mobile">
              These kits are free and restocked quarterly while supplies last. Come back each quarter to order more kits—and keep your students covered!
            </p>
            <p class="sh sub-header-mobile" :class="{ 'errorMsg-text': Object.keys(errors).length > 0 }">
              You have ordered {{ studentKitsOrdered }} kits in the past {{ studentKitOrderingWindowDays }} days
              and may request up to {{ remainingStudentKitAllowance }} more.
              See your <router-link class="pa-link" :to="{ name: 'OrderHistory' }">Order History</router-link>.
            </p>
            <p class="sh sub-header-mobile">
              To receive samples for your office, contact your CeraVe or La Roche-Posay Representative.
            </p>
            <p class="sh sub-header-mobile">
              Please <router-link class="pa-link" :to="{ name: 'Contact' }">contact us</router-link> with any questions—and to send us photos of our kits in action!
            </p>
          </div>
          <div class="im">
            <img src="@/assets/images/global/Sun-Heroes-STUDENT-Swag-Graphic.jpg" class="responsive"/>
          </div>
          <div class="ff">
            <div class="form-field">
              <label><span>*</span>School or program name</label> <input type="text" v-model="studentSchoolProname"
                                                                         :class="{ invalid: errors.studentSchoolProname }"
                                                                         @input="clear_error('studentSchoolProname')"/>
              <p class="errorMsg-text" v-if="errors.studentSchoolProname">
                School or program name is required. </p>
            </div>
            <div class="form-field half-col">
              <label>Presentation date</label> <input type="date" v-model="studentPresentationDate"
                                                      placeholder="MM/DD/YYYY"
                                                      :min="new Date().toISOString().slice(0, 10)"
                                                      :class="{ invalid: errors.studentPresentationDate }"
                                                      @input="clear_error('studentPresentationDate')"/>
              <p class="errorMsg-text" v-if="errors.studentPresentationDate">
                Invalid date format. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>School&nbsp;zip&nbsp;code</label> <input type="text" v-model="studentZip"
                                                                            placeholder="00000" maxlength="5"
                                                                            :class="{ invalid: errors.studentZip }"
                                                                            @input="clear_error('studentZip')"/>
              <p class="errorMsg-text" v-if="errors.studentZip">
                School zip code is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Number of kits needed</label> <div class="selectField request" style="width: 90%">
                <select
                  v-model="studentNeededKitNum"
                  :class="{ invalid: errors.studentNeededKitNum }"
                  @input="clear_error('studentNeededKitNum')"
                  @blur="checkKitNum">
                  <option
                    v-for="quantity in studentKitQuantities"
                    :key="quantity"
                    :value="quantity.toString()">
                    {{ quantity }}
                  </option>
                </select>
              </div>
              <p class="errorMsg-text" v-if="errors.studentNeededKitNum">
                {{ getErrorText(errors.studentNeededKitNum)  }}
              </p>
            </div>
            <div class="form-field orange-callout">
              <img src="@/assets/images/request-kits-four-six-weeks.png" alt=""/> <span>Please allow 4–6 weeks for your kits to arrive.</span>
            </div>
            <div class="form-field">
              <label><span>*</span>Grade level/age</label> <input type="text" v-model="studentGradeLevel"
                                                                  :class="{ invalid: errors.studentGradeLevel }"
                                                                  @input="clear_error('studentGradeLevel')"/>
              <p class="errorMsg-text" v-if="errors.studentGradeLevel">
                Grade level/age is required. </p>
            </div>
            <div class="double-col">
              <p class="sub-header-mobile">
                <strong>Where should we ship your<br class="header-br"/> student kits?</strong>
              </p>
            </div>
            <div class="form-field">
              <label><span>*</span>First name</label> <input type="text" v-model="studentFirstName"
                                                             :class="{ invalid: errors.studentFirstName }"
                                                             @input="clear_error('studentFirstName')"/>
              <p class="errorMsg-text" v-if="errors.studentFirstName">
                First name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Last name</label> <input type="text" v-model="studentLastName"
                                                            :class="{ invalid: errors.studentLastName }"
                                                            @input="clear_error('studentLastName')"/>
              <p class="errorMsg-text" v-if="errors.studentLastName">
                Last name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="studentAddressFirst"
                                                                   :class="{ invalid: errors.studentAddressFirst }"
                                                                   @input="clear_error('studentAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.studentAddressFirst">
                Street address is required. </p>
            </div>
            <div class="form-field">
              <label>Street address 2</label> <input type="text" v-model="studentAddressSecond"/>
            </div>
            <div class="form-field">
              <label><span>*</span>City</label> <input type="text" v-model="studentCity"
                                                       :class="{ invalid: errors.studentCity }"
                                                       @input="clear_error('studentCity')"/>
              <p class="errorMsg-text" v-if="errors.studentCity">
                City is required. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="studentState" :class="{ invalid: errors.studentState }"
                        @input="clear_error('studentState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.studentState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>Zip code</label> <input type="text" v-model="studentShipZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.studentShipZip }"
                                                           @input="clear_error('studentShipZip')"/>
              <p class="errorMsg-text" v-if="errors.studentShipZip">
                Zip code is required. </p>
            </div>
            <div class="gray-callout" v-if="showRefillKit">
              <img src="@/assets/images/request-kits-sample-cards.png" alt=""/> <label class="checkbox">
                <span class="checkbox-input">
                  <input type="checkbox" v-model="ranOutOfCards"/>
                  <span class="checkbox-control">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path fill="none" stroke="currentColor" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59"/>
                    </svg>
                  </span>
                </span> I've run out of cards and need more. </label>
            </div>
            <div class="submit-col" v-show="ranOutOfCards && showRefillKit">
              <p>
                <strong>How many would you like to add<br class="header-br"/> to this order?</strong>
              </p>
            </div>
            <div class="form-field half-col" v-show="ranOutOfCards">
              <label><span>*</span>Select quantity</label>
              <div class="selectField request">
                <select v-model="cardsQuantity" :class="{ invalid: errors.cardsQuantity }"
                        @input="clear_error('cardsQuantity')">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="150">150</option>
                </select>
                <p class="errorMsg-text" v-if="errors.cardsQuantity">
                  Please specify the number of cards needed.</p>
              </div>
            </div>
            <div></div>
            <div class="double-col" v-show="ranOutOfCards && showRefillKit">
              <label class="checkbox">
                <span class="checkbox-input">
                  <input type="checkbox" v-model="sameShippingAddress"/>
                  <span class="checkbox-control">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path fill="none" stroke="currentColor" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59"/>
                    </svg>
                  </span>
                </span> <strong class="checkbox-text">Ship to the same address as<br class="header-br"/> the student
                kits</strong> </label>
              <p v-show="!sameShippingAddress">
                <strong>Where should we ship your cards?</strong>
              </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>First name</label> <input type="text" v-model="cardsFirstName"
                                                             :class="{ invalid: errors.cardsFirstName }"
                                                             @input="clear_error('cardsFirstName')"/>
              <p class="errorMsg-text" v-if="errors.cardsFirstName">
                First name is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>Last name</label> <input type="text" v-model="cardsLastName"
                                                            :class="{ invalid: errors.cardsLastName }"
                                                            @input="clear_error('cardsLastName')"/>
              <p class="errorMsg-text" v-if="errors.cardsLastName">
                Last name is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="cardsAddressFirst"
                                                                   :class="{ invalid: errors.cardsAddressFirst }"
                                                                   @input="clear_error('cardsAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.cardsAddressFirst">
                Street address is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label>Street address 2</label> <input type="text" v-model="cardsAddressSecond"/>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>City</label> <input type="text" v-model="cardsCity"
                                                       :class="{ invalid: errors.cardsCity }"
                                                       @input="clear_error('cardsCity')"/>
              <p class="errorMsg-text" v-if="errors.cardsCity">
                City is required. </p>
            </div>
            <div class="form-field half-col" v-show="!sameShippingAddress">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="cardsState" :class="{ invalid: errors.cardsState }" @input="clear_error('cardsState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.cardState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col" v-show="!sameShippingAddress">
              <label><span>*</span>Zip code</label> <input type="text" v-model="cardsZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.cardsZip }"
                                                           @input="clear_error('cardsZip')"/>
              <p class="errorMsg-text" v-if="errors.cardsZip">
                Zip code is required. </p>
            </div>
            <div class="form-field error-row double-col" v-if="Object.keys(errors).length > 0">
              <p class="errorMsg-text">
                Please check the fields above to correct any errors and submit again. </p>
            </div>
            <div class="submit-col">
              <p class="footnote">
                Fields marked with an asterisk are required. </p>
              <div class="loader-container" :class="{ 'has-error': submitError && !showLoader }" aria-live="polite">
                <img v-if="showLoader" src="@/assets/images/global/loader.gif" alt="Submitting request"/>
                <p v-else-if="submitError" class="errorMsg-text">{{ submitError }}</p>
              </div>
            </div>
           <div class="superhero-cta">
             <button :disabled="disableSubmit || !!partialSubmission">Request <i class="fas fa-caret-right"></i></button>
             <div class="superhero-gif">
               <img src="@/assets/images/global/super-hero-4.gif" alt=""/>
             </div>
           </div>
          </div>
        </div>

        <div v-if="showStudentAllowancePlaceholder" class="mb-3">
          <h2>Student kit request & presentation information</h2>
          <div>
            <p><strong>Your remaining allowance is below the minimum 30-kit request.</strong></p>
            <p>
              You have ordered {{ studentKitsOrdered }} of {{ maximumStudentKitAllowance }} kits.
              Please check back after earlier orders fall outside the current 90-day eligibility window.
            </p>
          </div>
        </div>

         <div v-if="showStudentPlaceholder" class="mb-3">
          <h2>Student kit request & presentation information</h2>
          <div>
            <p><strong>Turns out saving the day is in high demand—our student kits are out of stock!</strong></p>
            <p>We’re gearing up for a fresh round, so please check back soon to place your request.</p>
          </div>
        </div>

      </form>
    </div>
  </section>
</template>
<script>
import { buildKitTypes } from '@/utils/orderKitTypes.mjs'
import {
  getStudentKitDisplayState,
  normalizePartialSubmission,
  normalizeStudentKitAllowance
} from '@/utils/studentKitAllowance.mjs'

export default {
  data () {
    return {
      showEducatorKit: false,
      showStudentKit: true,
      showRefillKit: false,
      showEducatorLoader: false,
      showRefillLoader: false,
      disableSubmit: false,

      showStudentPlaceholder: false,
      showStudentAllowancePlaceholder: false,
      showEducatorPlaceholder: false,

      educatorFirstName: this.$store.state.firstName,
      educatorLastName: this.$store.state.lastName,
      educatorAddressFirst: '',
      educatorAddressSecond: '',
      educatorCity: '',
      educatorState: '',
      educatorZip: '',

      studentSchoolProname: '',
      studentPresentationDate: '',
      studentZip: '',
      studentNeededKitNum: '',
      studentGradeLevel: '',
      studentFirstName: '',
      studentLastName: '',
      studentAddressFirst: '',
      studentAddressSecond: '',
      studentCity: '',
      studentState: '',
      studentShipZip: '',

      ranOutOfCards: false,
      sameShippingAddress: true,
      showLoader: false,
      submitError: '',
      cardsQuantity: '',
      cardsFirstName: '',
      cardsLastName: '',
      cardsAddressFirst: '',
      cardsAddressSecond: '',
      cardsCity: '',
      cardsState: '',
      cardsZip: '',

      studentKitsOrdered: 0,
      maximumStudentKitAllowance: 150,
      remainingStudentKitAllowance: 150,
      canOrderStudentKits: true,
      studentKitOrderingWindowDays: 90,
      studentKitEligibilityWindow: {},
      studentKitQuantities: [30, 60, 90, 120, 150],
      partialSubmission: null,

      errors: [],
      options: {}
    }
  },
  created () {
    this.getInitial()
  },
  watch: {
    studentNeededKitNum (newVal) {
      this.validateStudentKitAllowance(newVal)
    }
  },
  methods: {
    validateStudentKitAllowance (quantity) {
      if (quantity && parseInt(quantity) > this.remainingStudentKitAllowance) {
        this.$set(this.errors, 'studentNeededKitNum', [
          `Number of kits must be ${this.remainingStudentKitAllowance} or less in the past ${this.studentKitOrderingWindowDays} days.`
        ])
        return false
      }

      if (this.errors.studentNeededKitNum) {
        this.$delete(this.errors, 'studentNeededKitNum')
      }

      return true
    },
    checkKitNum () {
      if (this.errors.studentNeededKitNum) {
        alert(this.errors.studentNeededKitNum[0])
      }
    },
    async getInitial () {
      const _this = this

      this.showStudentPlaceholder = false
      this.showStudentAllowancePlaceholder = false
      this.showEducatorPlaceholder = false

      _this.axios.get(_this.$apiUrl + 'v1/account').then(function (response) {
        if (response.data.errors.length === 0) {
          const d = response.data.user
          _this.educatorFirstName = d.first_name
          _this.educatorLastName = d.last_name
          _this.educatorZip = d.practice_zip_code

          _this.studentFirstName = d.first_name
          _this.studentLastName = d.last_name
          _this.studentShipZip = d.practice_zip_code

          _this.cardsFirstName = d.first_name
          _this.cardsLastName = d.last_name
          _this.cardsZip = d.practice_zip_code
        }
      }).catch(function () {})

      const [hasOrdered, options, allowance] = await Promise.all([
        this.getHasOrderedKit(),
        this.getOptions(),
        this.getStudentKitAllowance()
      ])

      this.applyStudentKitAllowance(allowance.data)

      if (options.data.data && hasOrdered.data.errors.length === 0) {
        // only display placeholder when educator or student toggle disable from admin
        _this.showEducatorPlaceholder = options.data.data.disable_educator_kit?.toString() === '1' && !hasOrdered.data.has_ordered
        _this.showStudentPlaceholder = options.data.data.disable_student_kit?.toString() === '1'

        // educator kit visibility
        if (options.data.data.disable_educator_kit?.toString() === '1') {
          _this.showEducatorKit = false
        } else {
          if (hasOrdered.data.has_ordered) {
            _this.showEducatorKit = false
            _this.showEducatorPlaceholder = false
          } else {
            _this.showEducatorKit = options.data.data.disable_educator_kit?.toString() === '0'
          }
          if (parseInt(options.data.data.qty_educator_kit) < 1 || !options.data.data.qty_educator_kit) {
            _this.showEducatorKit = false
            _this.showEducatorPlaceholder = true
          }
        }

        // student kit visibility
        if (options.data.data.disable_student_kit?.toString() === '1') {
          _this.showStudentKit = false
        } else {
          if (hasOrdered.data.has_ordered) {
            _this.showStudentKit = true
          } else {
            _this.showStudentKit = options.data.data.disable_student_kit?.toString() === '0'
          }
          if (parseInt(options.data.data.qty_student_kit) < 30 || !options.data.data.qty_student_kit) {
            _this.showStudentKit = false
            _this.showStudentPlaceholder = true
          }
        }

        const studentDisplayState = getStudentKitDisplayState({
          orderingDisabled: options.data.data.disable_student_kit?.toString() === '1',
          inventoryQuantity: options.data.data.qty_student_kit,
          canOrder: this.canOrderStudentKits
        })
        _this.showStudentKit = studentDisplayState.showStudentKit
        _this.showStudentPlaceholder = studentDisplayState.showInventoryPlaceholder
        _this.showStudentAllowancePlaceholder = studentDisplayState.showAllowancePlaceholder

        // refill kit visibility
        _this.showRefillKit = hasOrdered.data.has_ordered &&
          parseInt(options.data.data.qty_refill_kit) >= 25 &&
          options.data.data.disable_student_kit?.toString() !== '1'
      }
    },
    getOptions () {
      return this.axios.get(this.$apiUrl + 'v1/admin/options/get', { preserveApiError: true, timeout: 30000 })
    },
    getStudentKitAllowance () {
      return this.axios.get(this.$apiUrl + 'v1/order/totalStudentKits', { preserveApiError: true, timeout: 30000 })
    },
    getHasOrderedKit () {
      return this.axios.post(this.$apiUrl + 'v1/wasStarterKitOrdered', null, { preserveApiError: true, timeout: 30000 })
    },
    applyStudentKitAllowance (allowanceData) {
      const allowance = normalizeStudentKitAllowance(allowanceData)
      this.studentKitsOrdered = allowance.studentKitsOrdered
      this.maximumStudentKitAllowance = allowance.maximumAllowance
      this.remainingStudentKitAllowance = allowance.remainingAllowance
      this.studentKitOrderingWindowDays = allowance.orderingWindowDays
      this.studentKitEligibilityWindow = allowance.eligibilityWindow
      this.studentKitQuantities = allowance.availableQuantities
      this.canOrderStudentKits = allowance.canOrder
    },
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') {
        delete this.errors[field]
      }
    },
    isOptionDisabled (option) {
      return option?.toString() === '1'
    },
    getOptionQuantity (option) {
      return parseInt(option, 10) || 0
    },
    getErrorText (error) {
      if (typeof error === 'string') {
        return error
      }

      if (Array.isArray(error)) {
        return error.map(item => this.getErrorText(item)).find(Boolean) || ''
      }

      if (error && typeof error === 'object') {
        return Object.keys(error).map(key => this.getErrorText(error[key])).find(Boolean) || ''
      }

      return ''
    },
    getResponseErrorText (responseData) {
      return this.getErrorText(responseData && responseData.errors) ||
        this.getErrorText(responseData && responseData.error) ||
        this.getErrorText(responseData && responseData.message) ||
        this.getErrorText(responseData)
    },
    getKitTypeLabel (kitType) {
      const labels = {
        educator: 'educator kit',
        student: 'student kits',
        refill: 'refill cards'
      }

      return labels[kitType] || kitType
    },
    clearSubmittedKitSelections (submittedKitTypes) {
      if (submittedKitTypes.indexOf('educator') >= 0) {
        this.showEducatorKit = false
      }

      if (submittedKitTypes.indexOf('student') >= 0) {
        this.studentNeededKitNum = ''
      }

      if (submittedKitTypes.indexOf('refill') >= 0) {
        this.ranOutOfCards = false
        this.cardsQuantity = ''
      }
    },
    async handlePartialSubmission (responseData) {
      const partialSubmission = normalizePartialSubmission(responseData.partialSubmission)
      this.partialSubmission = partialSubmission
      this.submitError = 'Some items were submitted. Please contact an administrator before requesting more kits.'
      this.clearSubmittedKitSelections(partialSubmission.submittedKitTypes)
      this.errors = {
        form: [
          'Some selected items were submitted. Do not retry the full request; review the details below.'
        ]
      }

      try {
        await this.getInitial()
      } catch (error) {
        this.errors.form.push(
          'Current availability could not be refreshed. Reload the page before taking another action.'
        )
      }
    },
    getEligibilityError (payload, eligibility) {
      const options = eligibility.options
      const kitTypes = payload.kitTypes.split('|')
      const studentRequested = this.getOptionQuantity(payload.studentNeededKitNum)
      const availableStudentQuantities = (eligibility.allowance.availableQuantities || [])
        .map(quantity => this.getOptionQuantity(quantity))
      const refillRequested = this.getOptionQuantity(payload.cardsQuantity)

      if (kitTypes.indexOf('educator') >= 0) {
        if (
          this.isOptionDisabled(options.disable_educator_kit) ||
          eligibility.hasOrdered ||
          this.getOptionQuantity(options.qty_educator_kit) < 1
        ) {
          return 'Educator kits are not available for this account.'
        }
      }

      if (kitTypes.indexOf('student') >= 0) {
        if (
          this.isOptionDisabled(options.disable_student_kit) ||
          this.getOptionQuantity(options.qty_student_kit) < 30 ||
          this.getOptionQuantity(options.qty_student_kit) < studentRequested
        ) {
          return 'Student kits are not available right now.'
        }

        if (
          !eligibility.allowance.canOrder ||
          availableStudentQuantities.indexOf(studentRequested) < 0
        ) {
          return `Please select an available quantity. You may request up to ${eligibility.allowance.remainingAllowance} more kits in the past ${eligibility.allowance.eligibilityWindow?.days || 90} days.`
        }
      }

      if (kitTypes.indexOf('refill') >= 0) {
        if (
          !eligibility.hasOrdered ||
          this.isOptionDisabled(options.disable_student_kit) ||
          !payload.ranOutOfCards ||
          refillRequested < 1 ||
          this.getOptionQuantity(options.qty_refill_kit) < refillRequested
        ) {
          return 'Refill cards are not available for this account.'
        }
      }

      return ''
    },
    async validateOrderEligibility (payload) {
      const [hasOrdered, options, allowance] = await Promise.all([
        this.getHasOrderedKit(),
        this.getOptions(),
        this.getStudentKitAllowance()
      ])

      if (!options.data.data || hasOrdered.data.errors.length !== 0 || allowance.data.errors.length !== 0) {
        return 'We could not verify kit availability. Please try again.'
      }

      this.applyStudentKitAllowance(allowance.data)

      return this.getEligibilityError(payload, {
        hasOrdered: hasOrdered.data.has_ordered,
        options: options.data.data,
        allowance: {
          availableQuantities: this.studentKitQuantities,
          canOrder: this.canOrderStudentKits,
          remainingAllowance: this.remainingStudentKitAllowance,
          eligibilityWindow: this.studentKitEligibilityWindow
        }
      })
    },
    getKitTypes () {
      return buildKitTypes({
        includeEducator: this.showEducatorKit,
        includeStudent: this.showStudentKit,
        includeRefill: this.showRefillKit && this.ranOutOfCards
      })
    },
    async sendFormData () {
      const _this = this
      if (_this.disableSubmit || _this.partialSubmission) return

      if (_this.showStudentKit && !_this.validateStudentKitAllowance(_this.studentNeededKitNum)) {
        _this.checkKitNum()
        return
      }

      _this.showLoader = true
      _this.submitError = ''
      _this.disableSubmit = true
      _this.errors = {}
      var payload = {
        educatorFirstName: _this.educatorFirstName,
        educatorLastName: _this.educatorLastName,
        educatorAddressFirst: _this.educatorAddressFirst,
        educatorAddressSecond: _this.educatorAddressSecond,
        educatorCity: _this.educatorCity,
        educatorState: _this.educatorState,
        educatorZip: _this.educatorZip,
        studentSchoolProname: _this.studentSchoolProname,
        studentPresentationDate: _this.studentPresentationDate,
        studentZip: _this.studentZip,
        studentNeededKitNum: _this.studentNeededKitNum,
        studentGradeLevel: _this.studentGradeLevel,
        studentFirstName: _this.studentFirstName,
        studentLastName: _this.studentLastName,
        studentAddressFirst: _this.studentAddressFirst,
        studentAddressSecond: _this.studentAddressSecond,
        studentCity: _this.studentCity,
        studentState: _this.studentState,
        studentShipZip: _this.studentShipZip,

        ranOutOfCards: _this.ranOutOfCards,
        cardsQuantity: _this.cardsQuantity,
        sameShippingAddress: _this.sameShippingAddress,
        cardsFirstName: _this.cardsFirstName,
        cardsLastName: _this.cardsLastName,
        cardsAddressFirst: _this.cardsAddressFirst,
        cardsAddressSecond: _this.cardsAddressSecond,
        cardsCity: _this.cardsCity,
        cardsState: _this.cardsState,
        cardsZip: _this.cardsZip,
        kitTypes: _this.getKitTypes()
      }
      if (this.showEducatorKit) { payload = { ...payload, educatorKitQuantity: 1 } }

      let orderRequestStarted = false
      try {
        const eligibilityError = await _this.validateOrderEligibility(payload)
        if (eligibilityError) {
          _this.submitError = eligibilityError
          _this.errors = {
            form: [eligibilityError]
          }
          return
        }

        orderRequestStarted = true
        const response = await _this.axios.post(_this.$apiUrl + 'v1/order', payload, { preserveApiError: true, timeout: 30000 })
        if (response.data && response.data.status === 'partial_failure' && response.data.partialSubmission) {
          await _this.handlePartialSubmission(response.data)
          return
        }
        const responseErrors = response.data && response.data.errors
        if (Array.isArray(responseErrors) && responseErrors.length === 0) {
          _this.$router.push({ name: 'RequestKitsThankYou' }).catch(() => {})
        } else {
          const submitError = _this.getResponseErrorText(response.data) ||
            'The request could not be submitted. Please try again.'
          _this.submitError = submitError
          _this.errors = responseErrors && typeof responseErrors === 'object'
            ? responseErrors
            : { form: [submitError] }
        }
        _this.showResponse = true
      } catch (error) {
        const responseData = error && error.response && error.response.data

        if (responseData && responseData.status === 'partial_failure' && responseData.partialSubmission) {
          await _this.handlePartialSubmission(responseData)
          return
        }

        const submitError = _this.getResponseErrorText(responseData) ||
          (orderRequestStarted
            ? 'We could not confirm whether your request was received. Check your order history or contact support before trying again.'
            : 'We could not verify kit availability. Please try again.')
        _this.submitError = submitError
        _this.errors = responseData && responseData.errors && typeof responseData.errors === 'object'
          ? responseData.errors
          : { form: [submitError] }
        setTimeout(() => {
          const invalidField = document.querySelector('input.invalid,select.invalid')
          if (invalidField) {
            invalidField.focus()
          }
        }, 200)
      } finally {
        _this.showLoader = false
        _this.disableSubmit = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: hidden;
}

.partial-submission {
  margin-bottom: 20px;
  padding: 16px;
  border: 2px solid #c24a25;
  background: #fff4ef;

  p {
    margin: 0 0 8px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

section.request-section {
  .container {
    h1 {
      margin-top: 1.1em;
      font-size: 45px;
      text-align: center;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        font-size: 60px;
        text-align: left;
      }
    }

    h2 {
      font-size: 22px;
      margin-top: 22px;
    }

    p {
      font-size: 18px;
    }

    .subhead-mt {
      margin-top: 22px;
    }

    .mb-1rem {
      margin-bottom: 1rem;
      line-height: 1.5;
    }

    .mb-4rem {
      margin-bottom: 4rem;
    }

    .footnote {
      font-size: 12px;
      color: #000;
      margin-bottom: 20px;
    }

    .form-container {
      display: grid;
      grid-template-columns: 1 1fr;
      grid-template-rows: auto;
      grid-template-areas:
        "he"
        "im"
        "ff";
      grid-gap: 30px;
    }
  }

  .pa-link {
    color: @color-dk-orange;
    text-decoration: underline;
    cursor: pointer;
  }

  .he {
    grid-area: he;
  }

  .im {
    grid-area: im;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .ff {
    grid-area: ff;
    display: grid;
    grid-gap: 30px;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0px;
    @media screen and (min-width: ~"@{mq-md-bp}em") {
      margin-bottom: 30px;
    }

    .double-col {
      grid-column: span 3;
    }

    .submit-col {
      grid-column: span 4;
    }

    .gray-callout {
      grid-column: span 4;
      background-color: @color-lt-gray;
      padding: 20px 25px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 84%;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        width: auto;
      }

      img {
        max-width: 68px;
        margin-right: 10px;
        @media screen and (min-width: ~"@{mq-md-bp}em") {
          margin-right: 0;
        }
        height: auto;
      }
    }

    .form-field {
      grid-column: span 4;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        grid-column: span 2;
      }

      textarea,
      select,
      input[type="text"],
      input[type="email"],
      input[type="name"],
      input[type="number"],
      input[type="date"],
      input[type="tel"] {
        margin-bottom: 0;
        margin-right: auto;

        &.invalid + .errorMsg-text {
          font-size: 1.5rem;
        }
      }

      &.half-col {
        grid-column: span 1;

        input {
          width: 89% !important;
          @media screen and (min-width: ~"@{mq-md-bp}em") {
            width: auto;
          }
        }

        // @media screen and (min-width: ~"@{mq-md-bp}em") {
        //   grid-column: span 1;
        // }
      }

      &.orange-callout {
        background-color: @color-yellow;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        grid-row: 5;
        padding: 10px 0px;
        width: 84%;
        // @media screen and (min-width: ~"@{mq-xs-bp}") {
        //   width: 100%;
        // }
        @media screen and (min-width: ~"@{mq-md-bp}em") {
          width: auto;
        }

        img {
          max-width: 47px;
          height: auto;
        }

        span {
          color: @color-txt-blue;
          font-size: 1.5rem;
          font-weight: 600;
          width: 70%;
        }
      }
    }
  }
}

@media screen and (min-width: ~"@{mq-md-bp}em") {
  section.request-section {
    .container {
      .form-container {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
        grid-template-areas:
          "he he he"
          "im ff ff";
      }
    }

    .ff {
      grid-template-columns: repeat(4, 1fr);

      .double-col {
        grid-column: span 4;
      }

      .submit-col {
        grid-column: span 4;
      }

      .form-field {
        &.orange-callout {
          grid-row: auto;
        }
      }
    }
  }
}

.superhero-image {
  width: 31rem;
  position: absolute;
  left: 30rem;
  top: 1rem;
  pointer-events: none;
}

.contact-header {
  display: flex;
  padding-top: 10rem;
  flex-flow: row wrap;

  h1 {
    font-size: 60px;
  }

  .link-color {
    color: @color-dk-orange !important;
    text-decoration: underline;
    cursor: pointer;
  }

  p {
    margin-top: 8rem;
  }
}

form {
  p {
    margin-top: 0 !important;

    &.sh {
      margin-top: 10px !important;
      margin-bottom: 10px;
      font-size: 18px;
    }
  }

  button {
    background-color: @color-orange;
    font-weight: 700;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;

    &:disabled {
      opacity: 0.6;
    }
  }
}

.form-row-1 {
  display: flex;
  padding-top: 4rem;
}

.form-row-2 {
  textarea {
    width: 72.3rem !important;
    height: 18rem !important;
  }
}

.superhero-cta {
  // display: flex;
  // flex-direction: column;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-left: 38%;
    margin-right: auto;
    margin-top: 60px;
    // margin-bottom: 30px;
  }

  button {
    background-color: @color-orange;
    cursor: pointer;
    border: none;
    font-weight: 700;
    font-family: @open-sans-font;
    text-transform: uppercase;
    color: @color-txt-blue;
    width: 14rem;
    height: 4.5rem;
    font-size: 19px;
    text-align: left;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .fa-caret-right {
      margin-left: 10px;
    }
  }

  .superhero-gif {
    position: relative;
    left: 15rem;
    top: -62px;
    width: 72px;

    img {
      width: 9rem;
    }
  }
}

.loader-container {
  width: 32px;
  height: 32px;

  &.has-error {
    width: auto;
    height: auto;
  }
}

input {
  width: 89% !important;
  @media (max-width: 767px) {
    width: 100% !important;
  }
  @media (max-width: 400px) {
    width: 85% !important;
  }
  @media screen and (min-width: ~"@{mq-md-bp}em") {
    width: auto;
  }
}

.header-mobile {
  width: 76%;
  @media screen and (min-width: 600px) {
    width: auto;
  }
}

.sub-header-mobile {
  // width: 120%;
  // @media screen and (min-width: 600px) {
  //   width: auto;
  // }
}

.header-br {
  display: block;
  @media screen and (min-width: 600px) {
    display: none;
  }
}
.mb-3 {
  margin-bottom: 3rem;
}
</style>
